import React, { useEffect, useState } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button, Typography, Tabs, message, Spin } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import PopupModal from "../../../../../Components/PopupModal";
import * as propertyActions from "../../../../../actionCreators/Property";
import { Link, useParams } from "react-router-dom";

import "../style/propertyListing.css";
import MLProperties from "./MLProperties";
import MLEngine from "./MLEngine";

const { TabPane } = Tabs;

const DetectedProperties = ({ getMlProperties, Mlproperties }) => {
  const history = useHistory();
  const [pageKey, setPageKey] = React.useState();
  const [activeTab, setActiveTab] = React.useState("");
  const [count, setCount] = useState(0);
  const { id } = useParams();
  useEffect(() => {
    if (Mlproperties.data) {
      setCount(Mlproperties.pagination.count);
    }
  }, [Mlproperties]);
  function tabChange(key) {
    if (key === "all") {
      getMlProperties({ page: 0, pageSize: 10 });
    } else if (key === "ml-engine") {
      // getMlProperties();
    }
    setPageKey(key);
    setActiveTab(pageKey);
    history.push("/detected/" + key);
  }
  return (
    <div>
      <div className="header">
        <Typography className="heading">Detect Properties</Typography>
        <div>
          <Button
            className="search-property-button"
            type="ghost"
            icon={<SearchOutlined />}
            onClick={() => history.push("/search-property")}
          >
            SEARCH PROPERTIES
          </Button>
        </div>
      </div>
      <div>
        <Tabs
          activeKey={id}
          defaultActiveKey={id}
          onChange={tabChange}
          className="tab-main"
        >
          <TabPane tab="ML ENGINE" key="search" className="tab-pane">
            <MLEngine />
          </TabPane>
          <TabPane
            tab={`PROPERTIES DETECTED ( ${count ? count : "0"} )`}
            key="all"
            className="tab-pane"
          >
            <MLProperties />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};
const mapStateToProps = ({ property: { Mlproperties } }) => ({ Mlproperties });

const mapDispatchToProps = (dispatch) => ({
  getMlProperties: bindActionCreators(
    propertyActions.getMlProperties,
    dispatch
  ),
});

DetectedProperties.propTypes = {
  getMlProperties: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DetectedProperties);
